
import { Textarea } from "@/components/ui/textarea";

interface DocumentContentProps {
  content: string | null;
  isEditing: boolean;
  editContent?: string;
  onEditContentChange?: (content: string) => void;
  isLoading?: boolean;
}

export function DocumentContent({
  content,
  isEditing,
  editContent = "",
  onEditContentChange,
  isLoading = false
}: DocumentContentProps) {
  const formatContent = (text: string | null) => {
    if (!text) return "";
    
    let formattedText = text.replace(/\[LOGO\]/g, '');
    formattedText = formattedText.replace(/(\d+\.|\-)\s/g, '\n$1 ');
    formattedText = formattedText.replace(/\.\s+/g, '.\n\n');
    
    return formattedText.trim();
  };

  return (
    <div className="bg-white rounded-lg p-4 sm:p-8 shadow-sm overflow-x-hidden">
      {isEditing ? (
        <Textarea
          value={editContent}
          onChange={(e) => onEditContentChange?.(e.target.value)}
          className="min-h-[550px] w-full font-mono text-sm border-none focus-visible:ring-0"
          placeholder="Rediger dokumentet her..."
          disabled={isLoading}
        />
      ) : (
        <div className="whitespace-pre-wrap font-serif text-base leading-relaxed break-words">
          {formatContent(content)}
        </div>
      )}
      <div className="text-right text-sm text-gray-500 mt-8">
        Laget av Advokai
      </div>
    </div>
  );
}
